var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStampDuty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 62h7.5v-3l8.5-5 1-11-4-3.5L33 62zM19 57V36l-5 8.5V57h5z",
    fill: "#E1F8F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 62H20V16h27.094L54 22.953v5.35",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.214 57H14V11h30v2.14M47 16v7h7",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 57h9v-7.765L30.5 46 26 49.235V57z",
    fill: "#FFF7EE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35 55.167V57h-9v-7.765L30.5 46l2.25 1.833",
    stroke: "#7E776E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30 51l2 2 5-4",
    stroke: "#7E776E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.563 65.665c2.94 1.699 7.108 2.76 11.73 2.76 4.621 0 9.766-1.061 12.707-2.76v-7.016l-8.797-4.398V42.52s3.64-3.01 3.42-5.865c-.28-3.661-3.66-4.493-7.33-4.4-3.503.09-6.544.908-6.843 4.4-.254 2.97 3.91 5.865 3.91 5.865v11.73l-8.797 4.398v7.016z",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.292 61.409c-4.621 0-8.789-1.06-11.73-2.76m17.107 2.26c.673-.13 1.326-.284 1.955-.46",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25h10M25 31h15M25 38h7",
    stroke: "#10C98E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgStampDuty;